import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
import { useGetProductByUpc } from 'app/core/api/product/api-product';
import { silenceError } from 'app/core/errors/error-utils';
import Button from 'app/shared/components/button/Button';
import FormTextInput from 'app/shared/components/form-input/FormTextInput';
import Icon from 'app/shared/components/icon/Icon';
import IconLib from 'app/shared/components/icon/icon-lib';
import { ErrorText, PadCollapse } from 'app/shared/components/misc';
import Body from 'app/shared/components/typography/body/Body';
import Form from 'app/shared/frames/Form';
import styledMixins from 'app/styles/styledMixins';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import {} from 'styled-components/macro';

type FormValues = {
  barcode: string;
};

export default function ProductEnterBarcode(): JSX.Element {
  const history = useHistory();

  const {
    request$: lookupProduct$,
    error: lookupError,
    sending,
  } = useGetProductByUpc();

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { control, handleSubmit, errors, watch } =
    useForm<FormValues>({
      mode: 'onTouched',
    });

  const requestSearch = ({ barcode }: FormValues) => {
    lookupProduct$(barcode).subscribe({
      complete: () =>
        history.push(
          ConsumerRoutePath.PRODUCT_DATABASE_LOOKUP_RESULT
        ),
      ...silenceError,
    });
  };

  const barcodeInput = watch('barcode');

  return (
    <>
      <Body color="primary" withNext>
        What’s your product UPC barcode?
      </Body>
      <Form onSubmit={handleSubmit(requestSearch)}>
        <FormTextInput
          autoFocus
          icon={IconLib.EDIT}
          controlName="barcode"
          placeholder="Enter barcode digits here"
          inputProps={{ inputMode: 'numeric' }}
          classicPlaceholder
          css={!errors.barcode ? styledMixins.withNext : ''}
          optional
          rules={{
            pattern: {
              value: /^[0-9]*$/,
              message: 'Barcode must contain digits (0-9) only',
            },
          }}
          {...{ control, errors }}
        />
        <ErrorText message={lookupError} />
        <Button
          startIcon={IconLib.SEARCH}
          disabled={!barcodeInput}
          pending={sending}
          type="submit"
        >
          Look up barcode
        </Button>
      </Form>
      <PadCollapse pad={3} />
      <Button
        to={ConsumerRoutePath.PRODUCT_SEARCH_CATALOG}
        endIcon={
          <Icon className="-mr-1 ml-1" icon={IconLib.CHEVRON_RIGHT} />
        }
      >
        Search product name instead
      </Button>
    </>
  );
}
